import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";
import { useIsFeatureFlagEnabled } from "@circle-react/hooks/UseCommunitySetting";

import { t } from "@/i18n-js/instance";
import { usePartnerOnboardingModal } from "@/react/components/Modals/PartnerOnboardingModal/usePartnerOnboardingModal";
import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

export const useCirclePartnerBadge = () => {
  const isAdmin = useIsCommunityAdmin();
  const isAdminArea = useIsAdminArea();
  const isPartnerProgramEnabled = useIsFeatureFlagEnabled(
    "growth_partner_program_enabled",
  );
  const { trackEvent } = useEventsTracker();
  const { startPartnerOnboarding } = usePartnerOnboardingModal();

  return {
    shouldShow: isAdmin && isAdminArea && isPartnerProgramEnabled,
    title: t("circle_partner_badge.title"),
    description: t("circle_partner_badge.description"),
    onClick: () => {
      trackEvent("circle_partner_badge.clicked", {});
      void startPartnerOnboarding();
    },
  };
};
